/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_Email_LabelInputs */

const en_claims_email_label = /** @type {(inputs: Claims_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const fr_claims_email_label = /** @type {(inputs: Claims_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Courriel`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Claims_Email_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_email_label = /** @type {((inputs?: Claims_Email_LabelInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_Email_LabelInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_email_label(inputs)
	return fr_claims_email_label(inputs)
});